import { FormFieldConfigType, INPUT_TYPES, TEXT_INPUT_TYPES } from "../../../../types";
import { CLAIM_DETAILS_CONSTANTS } from "../../../constants";
import { preProcessFormFields } from "../../../../tools";
import { HANDLING_UNIT_IDENTIFIER_OPTIONS, WEIGHT_UNIT_TYPE_OPTIONS } from "../../../options";

export const formFieldsConfig: FormFieldConfigType[] = [
  {
    name: "allClaimDetailsFields",
    type: INPUT_TYPES.FIELD_GROUP,
    contained: true,
    label: "Claim Details",
    fields: [
      {
        name: CLAIM_DETAILS_CONSTANTS.SINGLE_ITEM_CLAIM,
        label: "Are you claiming for a single item?",
        description: "",
        type: INPUT_TYPES.RADIO,
        options: [
          { value: "true", label: "Yes, I am claiming for a single item" },
          { value: "false", label: "No, I am claiming for multiple items" },
        ],
        onChange: (
          // eslint-disable-next-line @typescript-eslint/no-explicit-any -- onChange detail type is CheckboxProps.ChangeDetail but BaseFormField.onChange types it as any
          { detail }: { detail: any },
          formState,
          updateForm
        ) => {
          const isSingleItem = detail.value === "true";
          updateForm({
            ...formState,
            [CLAIM_DETAILS_CONSTANTS.SINGLE_ITEM_CLAIM]: {
              ...formState[CLAIM_DETAILS_CONSTANTS.SINGLE_ITEM_CLAIM],
              value: detail.value,
            },
            [CLAIM_DETAILS_CONSTANTS.SINGLE_ITEM_DETAILS_GROUP]: {
              ...formState[CLAIM_DETAILS_CONSTANTS.SINGLE_ITEM_DETAILS_GROUP],
              hidden: !isSingleItem,
            },
            [CLAIM_DETAILS_CONSTANTS.MULTIPLE_ITEM_CLAIM_ATTACHMENT]: {
              ...formState[CLAIM_DETAILS_CONSTANTS.MULTIPLE_ITEM_CLAIM_ATTACHMENT],
              hidden: !!isSingleItem,
            },
          });
        },
      },
      {
        name: CLAIM_DETAILS_CONSTANTS.SINGLE_ITEM_DETAILS_GROUP,
        type: INPUT_TYPES.FIELD_GROUP,
        contained: false,
        label: "",
        fields: [
          {
            name: CLAIM_DETAILS_CONSTANTS.QUANTITY,
            label: "Qty",
            description: "",
            placeholderText: "Please enter Quantity",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.NUMBER,
          },
          {
            name: CLAIM_DETAILS_CONSTANTS.HANDLING_UNIT_IDENTIFIER,
            label: "Handling Unit Identifier",
            description: "",
            placeholderText: "Select Handling Unit Identifier",
            type: INPUT_TYPES.SELECT,
            options: HANDLING_UNIT_IDENTIFIER_OPTIONS,
          },
          {
            name: CLAIM_DETAILS_CONSTANTS.WEIGHT,
            label: "Weight",
            description: "",
            placeholderText: "Please enter Weight",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.NUMBER,
          },
          {
            name: CLAIM_DETAILS_CONSTANTS.WEIGHT_UNIT_TYPE,
            label: "Unit",
            description: "",
            placeholderText: "Select Unit",
            type: INPUT_TYPES.SELECT,
            options: WEIGHT_UNIT_TYPE_OPTIONS,
          },
          {
            name: CLAIM_DETAILS_CONSTANTS.DESCRIPTION_OF_CARGO_OR_PROPERTY,
            label: "Description of missing/damaged cargo/property",
            description: "",
            placeholderText: "Please enter the description of the missing/damaged cargo/properties",
            type: INPUT_TYPES.TEXTAREA,
          },
          {
            name: CLAIM_DETAILS_CONSTANTS.MATERIAL_PART_NUMBER,
            label: "MPN",
            description: "",
            placeholderText: "Material Part Number",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
          },
          {
            name: CLAIM_DETAILS_CONSTANTS.AMAZON_PART_NUMBER,
            label: "APN",
            description: "",
            placeholderText: "Amazon Part Number",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
          },
          {
            name: CLAIM_DETAILS_CONSTANTS.PURCHASE_ORDER_NUMBER,
            label: "PO#",
            description: "",
            placeholderText: "Purchase Order Number",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
          },
          {
            name: CLAIM_DETAILS_CONSTANTS.WAREHOUSE_MANAGEMENT_SYSTEM_ORDER_NUMBER,
            label: "WMS Order#",
            description: "",
            placeholderText: "Warehouse Management System Order Number",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
          },
          {
            name: CLAIM_DETAILS_CONSTANTS.AMAZON_STANDARD_IDENTIFICATION_NUMBER,
            label: "ASIN",
            description: "",
            placeholderText: "Amazon Standard Identification Number",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
          },
        ],
      },
      {
        name: CLAIM_DETAILS_CONSTANTS.MULTIPLE_ITEM_CLAIM_ATTACHMENT,
        label: "Multiple Claim Item attachment",
        placeholderText: "",
        type: INPUT_TYPES.UPLOAD,
        constraintText: "The maximum size of files uploaded here is 50MB",
        multiple: false,
        acceptedFileTypes: ".xls, .xlsx, .csv, .odf",
        customAlert: {
          display: true,
          dismissible: false,
          type: "info",
          header: "",
          value: "",
          statusIconAriaLabel: "Info",
          dismissAriaLabel: "Dismiss",
        },
      },
    ],
  },
];

export const formFieldsConfigProcessed = preProcessFormFields(formFieldsConfig);
